import React, { useState } from "react";
import foxIdeaImg from "../assets/ChatGPT_Image_May_19__2025__01_30_29_PM-removebg-preview.png";
import { TrainingsSection } from "./TrainingsSection";
import { KursetGallery } from "./KursetGallery";
import { InternshipSection } from "./InternshipSection";
import { Footer } from "./Footer";
import "./Kurset.css";

export function Kurset() {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ name: "", email: "", phone: "", course: "" });

  const courses = [
    "Dizajn Grafik",
    "Foto & Video",
    "Programim",
    "Frontend",
    "Wordpress",
    "Inteligjencë Artificiale"
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = `Aplikim për kurs: ${formData.course}`;
    const body = `Emri: ${formData.name}\nEmail: ${formData.email}\nTelefoni: ${formData.phone}\nKursi: ${formData.course}`;
    window.location.href = `mailto:academy@fox.illyrian.marketing?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  };

  return (
    <>
      <section className="fox-hero">
        <div className="fox-hero-content">
          <div className="fox-hero-text">
            <h1>
              ZBULO <span className="highlight-white">FOX ACADEMY</span><br />
              MË SHUMË SE NJË TRAJNIM!
            </h1>
            <p>
              Ne jemi komuniteti më i madh kreativ në Kosovë.<br />
              Te Fox Academy, nuk merr vetëm njohuri praktike — por edhe eksperiencë reale pune, mentorim nga profesionistë, projekte të vërteta dhe një rrjet mbështetës që të ndjek edhe pas përfundimit të trajnimit.<br /><br />
              <span className="call">Bashkohu me ne dhe ktheje pasionin tënd në profesion!</span>
            </p>
          </div>
          <div className="fox-hero-illustration">
            <img src={foxIdeaImg} alt="Fox ndez llampën" className="fox-hero-image" />
            <button className="fox-hero-btn" onClick={() => setShowForm(true)}>
              Apliko Tani
            </button>
          </div>
        </div>
      </section>

      {/* Application Form Modal */}
      {showForm && (
        <div className="overlay">
          <form className="apply-form" onSubmit={handleSubmit}>
            <h3>Formular Aplikimi për Praktikë</h3>
            <label>
              Emri i plotë
              <input type="text" name="name" value={formData.name} onChange={handleChange} required />
            </label>
            <label>
              Email
              <input type="email" name="email" value={formData.email} onChange={handleChange} required />
            </label>
            <label>
              Telefoni
              <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required />
            </label>
            <label>
              Zgjidh kursin
              <select name="course" value={formData.course} onChange={handleChange} required>
                <option value="" disabled>-- Zgjidh --</option>
                {courses.map(c => <option key={c} value={c}>{c}</option>)}
              </select>
            </label>
            <div className="form-buttons">
              <button type="submit">Dërgo Aplikimin</button>
              <button type="button" onClick={() => setShowForm(false)}>Mbyll</button>
            </div>
          </form>
        </div>
      )}

      {/* Other sections */}
      <TrainingsSection />
      <KursetGallery />
      <InternshipSection />
      <Footer />
    </>
  );
}
